import { IconProps } from "interfaces/icons";

const TrendingUpIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 24;

	if (size) {
		height = size;
	}

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={height}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color || "#0A0E27"}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
			<polyline points="17 6 23 6 23 12" />
		</svg>
	);
};

export default TrendingUpIcon;
